/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "0.1.0 nightly 2025-05-18",
    versionChannel: "nightly",
    buildDate: "2025-05-18T00:07:45.948Z",
    commitHash: "4b8196ad58cf5e253054ddd2f929950ab977bf75",
};
